(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE={id:"gamba-web@202507040022"};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = 1160
// module chunks = 4